import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mvp-list-skeleton',
  templateUrl: './list-skeleton.component.html',
})
export class ListSkeletonComponent implements OnInit {

  itemsNumber: number[] = Array(8).fill(0);
  environment = environment;
  constructor() { }

  ngOnInit() {}


}
